module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive) return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function () {

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post', headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus', placement: 'bottom', container: 'body'
        });
    };

    module.initStickyEl = function () {

        // Get sticky el's
        let el = $('.is-sticky');

        sessionStorage.setItem('height', $('header').height());

        // When the user scrolls the page, execute myFunction
        window.onscroll = function () {
            module.addStickyClass();
        };

        module.addStickyClass();
    };

    module.addStickyClass = function () {

        let body = $('body');

        let height = sessionStorage.getItem('height') ? sessionStorage.getItem('height') : $('header').height();

        if (window.pageYOffset >= (height / 2) && window.pageYOffset < height) {
            body.addClass("before-stuck").removeClass("stuck").css('padding-top', '0');
        } else if (window.pageYOffset == 0) {
            body.removeClass("stuck").removeClass("before-stuck").css('padding-top', '0');
        } else if (window.pageYOffset > height) {
            body.addClass("stuck").removeClass("before-stuck").css('padding-top', height + 'px');

        }

    };


    // module.navDropdownHover = function () {
    //
    //     const $dropdown = $(".dropdown");
    //     const $dropdownToggle = $(".dropdown-toggle");
    //     const $dropdownMenu = $(".dropdown-menu");
    //     const showClass = "show";
    //
    //     $(window).on("load resize", function() {
    //         if (this.matchMedia("(min-width: 768px)").matches) {
    //             $dropdown.hover(
    //                 function() {
    //                     const $this = $(this);
    //                     $this.addClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "true");
    //                     $this.find($dropdownMenu).addClass(showClass);
    //                 },
    //                 function() {
    //                     const $this = $(this);
    //                     $this.removeClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "false");
    //                     $this.find($dropdownMenu).removeClass(showClass);
    //                 }
    //             );
    //         } else {
    //             $dropdown.off("mouseenter mouseleave");
    //         }
    //     });
    // };


    module.announcementBarDismiss = function () {
        if ($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.initLightbox = function () {
        require('ekko-lightbox');
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                leftArrow: '<i class="fa fa-chevron-left left"></i>',
                rightArrow: '<i class="fa fa-chevron-right right"></i>'
            });
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        $('.slick.testimonials').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            prevArrow: $('.slick-prev'),
            nextArrow: $('.slick-next'),


            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },

                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });

        $('.slick.shortcode-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: false,
            dots: true,
            cssEase: 'linear',
        });

        if ($('.slick.logos').length) {
            $('.slick.logos').slick({
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                autoplay: true,
                arrows: false,
                speed: 4000,
                autoplaySpeed: 0,
                cssEase: 'linear',

                responsive: [{
                    breakpoint: 1500, settings: {
                        slidesToShow: 6
                    }
                }, {
                    breakpoint: 1300, settings: {
                        slidesToShow: 5
                    }
                }, {
                    breakpoint: 968, settings: {
                        slidesToShow: 3
                    }
                },

                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        }

        $('.slick.slides').slick({
            infinite: true, slidesToShow: 1, slidesToScroll: 1, autoplay: false, arrows: false, dots: true,
        });

        $('.slick.carousel').slick({
            infinite: true, slidesToShow: 2, slidesToScroll: 1, draggable: false, responsive: [{
                breakpoint: 968, settings: {
                    slidesToShow: 1
                }
            },]
        });

    };


    module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.faq-header').attr('id');

            if (getHeaderEl) module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let el = $(this).find('span'), e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value')) el.html(el.data('value') ? el.data('value') : e);
        });
    };


    module.drawSVG = function () {

        var wrapper = document.querySelector('.wrapper svg')

        // We are only adding and removing the 'active' class,
        // the entire animation is defined in the CSS code
        function draw() {
            wrapper.classList.add('active')
        }

        // Play draw animation once
        setTimeout(draw, 300)
    };

    module.movingText = function () {

        $(document).ready(function () {
            var containers = $('.moving-text');

            if (containers.length) {
                containers.each(function () {
                    var container = $(this);

                    // Support small text - copy to fill screen width
                    if (container.find('.scrolling-text').outerWidth() < $(window).width()) {
                        var windowToScrolltextRatio = Math.round($(window).width() / container.find('.scrolling-text').outerWidth()),
                            scrollTextContent = container.find('.scrolling-text .scrolling-text-content').text(),
                            newScrollText = '';
                        for (var i = 0; i < windowToScrolltextRatio; i++) {
                            newScrollText += ' ' + scrollTextContent;
                        }
                        container.find('.scrolling-text .scrolling-text-content').text(newScrollText);
                    }

                    // Init variables and config
                    var scrollingText = container.find('.scrolling-text'),
                        scrollingTextWidth = scrollingText.outerWidth(),
                        scrollingTextHeight = scrollingText.outerHeight(true),
                        startLetterIndent = parseInt(scrollingText.find('.scrolling-text-content').css('font-size'), 10) / 4.8,
                        startLetterIndent = Math.round(startLetterIndent),
                        scrollAmountBoundary = Math.abs($(window).width() - scrollingTextWidth), transformAmount = 0,
                        leftBound = 0, rightBound = scrollAmountBoundary,
                        transformDirection = container.hasClass('left-to-right') ? -1 : 1, transformSpeed = 200;

                    // Read transform speed
                    if (container.attr('speed')) {
                        transformSpeed = container.attr('speed');
                    }

                    // Make scrolling text copy for scrolling infinity
                    container.append(scrollingText.clone().addClass('scrolling-text-copy'));
                    container.find('.scrolling-text').css({'position': 'absolute', 'left': 0});
                    container.css('height', scrollingTextHeight);

                    var getActiveScrollingText = function (direction) {
                        var firstScrollingText = container.find('.scrolling-text:nth-child(1)');
                        var secondScrollingText = container.find('.scrolling-text:nth-child(2)');

                        var firstScrollingTextLeft = parseInt(container.find('.scrolling-text:nth-child(1)').css("left"), 10);
                        var secondScrollingTextLeft = parseInt(container.find('.scrolling-text:nth-child(2)').css("left"), 10);

                        if (direction === 'left') {
                            return firstScrollingTextLeft < secondScrollingTextLeft ? secondScrollingText : firstScrollingText;
                        } else if (direction === 'right') {
                            return firstScrollingTextLeft > secondScrollingTextLeft ? secondScrollingText : firstScrollingText;
                        }
                    }

                    $(window).on('wheel', function (e) {
                        var delta = e.originalEvent.deltaY;

                        if (delta > 0) {
                            // going down
                            transformAmount += transformSpeed * transformDirection;
                            container.find('.scrolling-text .scrolling-text-content').css('transform', 'skewX(10deg)');
                        } else {
                            transformAmount -= transformSpeed * transformDirection;
                            container.find('.scrolling-text .scrolling-text-content').css('transform', 'skewX(-10deg)');
                        }
                        setTimeout(function () {
                            container.find('.scrolling-text').css('transform', 'translate3d(' + transformAmount * -1 + 'px, 0, 0)');
                        }, 10);
                        setTimeout(function () {
                            container.find('.scrolling-text .scrolling-text-content').css('transform', 'skewX(0)');
                        }, 500)

                        // Boundaries
                        if (transformAmount < leftBound) {
                            var activeText = getActiveScrollingText('left');
                            activeText.css({'left': Math.round(leftBound - scrollingTextWidth - startLetterIndent) + 'px'});
                            leftBound = parseInt(activeText.css("left"), 10);
                            rightBound = leftBound + scrollingTextWidth + scrollAmountBoundary + startLetterIndent;

                        } else if (transformAmount > rightBound) {
                            var activeText = getActiveScrollingText('right');
                            activeText.css({'left': Math.round(rightBound + scrollingTextWidth - scrollAmountBoundary + startLetterIndent) + 'px'});
                            rightBound += scrollingTextWidth + startLetterIndent;
                            leftBound = rightBound - scrollingTextWidth - scrollAmountBoundary - startLetterIndent;
                        }
                    });
                })
            }
        });
    };


    module.opacityFade = function () {

        $(window).scroll(function () {
            var homeTop = $(window).scrollTop();

            $(".fader").each(function () {
                var height = $(this).height();
                var offset = $(this).offset().top;
                var opacity = (height - homeTop + offset) / height;

                $(this).css("opacity", opacity);
            });
        });
    };


    module.backgroundColourTransition = function () {


        $(window).scroll(function() {

            // selectors
            var $window = $(window),
                $body = $('.background-transition'),
                $panel = $('.panel');

            // Change 33% earlier than scroll position so colour is there when you arrive.
            var scroll = $window.scrollTop() + ($window.height() / 3);

            $panel.each(function () {
                var $this = $(this);

                // if position is within range of this panel.
                // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
                // Remember we set the scroll to 33% earlier in scroll var.
                if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {

                    // Remove all classes on body with color-
                    $body.removeClass(function (index, css) {
                        return (css.match (/(^|\s)color-\S+/g) || []).join(' ');
                    });

                    // Add class of currently active div
                    $body.addClass('color-' + $(this).data('color'));
                }
            });

        }).scroll();

    };






    return module;

};
